module.exports = __webpack_public_path__ + "static/media/xls.7bf7084e.png";